import { render, staticRenderFns } from "./ListTransition.vue?vue&type=template&id=588b89ca&scoped=true"
import script from "./ListTransition.vue?vue&type=script&lang=ts"
export * from "./ListTransition.vue?vue&type=script&lang=ts"
import style0 from "./ListTransition.vue?vue&type=style&index=0&id=588b89ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b89ca",
  null
  
)

export default component.exports